export default __webpack_public_path__ + "static/media/upload_personalize.d2672906.svg";